<script>
import Vue from 'vue';
import {required, email} from 'vuelidate/lib/validators'
import {mapState, mapActions} from 'vuex';
import PreloaderItem from '../PreloaderItem/PreloaderItem.vue';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue'

export default Vue.extend({
    components: {
        PreloaderItem,
        SelectLanguage
    },
    data () {
        return {
            email: undefined,
            pass: undefined
        }
    },
    validations: {
        email: {
            required,
            email
        },
        pass: {
            required
        }
    },
    computed: {
        ...mapState({
            loading: state => state.auth.login.loading,
            message: state => state.auth.login.message
        }),
        emailClasses () {
            return {
                'sign-in-page__input--error': this.$v.email.$dirty && this.$v.email.$error,
                'sign-in-page__input--success': this.$v.email.$dirty && !this.$v.email.$error
            }
        },
        passClasses () {
            return {
                'sign-in-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'sign-in-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            }
        }
    },
    destroyed() {
        this.setMessage(undefined);
    },
    methods: {
        ...mapActions({
            authenticate: 'auth/authenticate',
            setMessage: 'auth/setSignInMessage'
        }),
        submit () {
            this.$v.$touch();

            if (!this.$v.pass.$error && !this.$v.email.$error) {
                this.authenticate({
                    email: this.email,
                    pass: this.pass
                });
            }
        }
    }
});
</script>
<template>
    <div class="sign-in-page">
        <div class="sign-in-page__heading">{{ $t('signIn.heading') }}</div>
        <div class="sign-in-page__paragraph">{{ $t('signIn.description') }}</div>
        <div v-if="message" :class="`sign-in-page__alert--${message.level}`" class="sign-in-page__alert">
            {{ $t(message.text) }}
        </div>
        <div class="sign-in-page__form">
            <div class="sign-in-page__input-group">
                <input :placeholder="$t('signIn.email.placeholder')"
                       v-model="email"
                       :class="emailClasses"
                       type="email"
                       class="sign-in-page__input"
                       @input="$v.email.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.email.$dirty && !$v.email.required" class="sign-in-page__input-help">{{ $t('signIn.email.errors.required') }}</span>
                <span v-if="$v.email.$dirty && !$v.email.email" class="sign-in-page__input-help">{{ $t('signIn.email.errors.email') }}</span>
            </div>
            <div class="sign-in-page__input-group">
                <input :placeholder="$t('signIn.pass.placeholder')"
                       v-model="pass"
                       :class="passClasses"
                       type="password"
                       class="sign-in-page__input"
                       @input="$v.pass.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.pass.$dirty && !$v.pass.required" class="sign-in-page__input-help">{{ $t('signIn.pass.errors.required') }}</span>
            </div>
            <div class="sign-in-page__input-group">
                <button :disabled="loading" class="sign-in-page__submit" @click="submit">
                    <span v-if="!loading">{{ $t('signIn.button') }}</span>
                    <preloader-item v-if="loading"/>
                </button>
            </div>
        </div>
        <router-link to="/forgot-password" class="sign-in-page__forgot-password-link">{{ $t('signIn.forgotPasswordLink') }}</router-link>
        <select-language/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/SignInPage/SignInPage.vue